// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
    flex-grow: 1;
    border-radius: 5px;
    margin: 10px;
}

.heading {
    margin: -3px -3px 0 auto;
    font-size: 0.8rem;
    color: black;
    width: fit-content;
    padding: 2px 15px 2px 15px;
    border-radius: 4px;
}

.box_internal {
    height: calc(100% - 0.8rem - 12px);
    width: 100%;
    overflow: scroll;
}

.v1 {
    border: 3px solid white;
    background-color: rgba(255, 255, 255, 0.075);
    backdrop-filter: blur(3px);
}
.v1.heading {
    background-color: white;
}

.v2 {
    border: 3px solid rgb(255, 145, 0);
    background-color: rgb(255, 145, 0, 0.075);
    backdrop-filter: blur(2px);
}
.v2.heading {
    background-color: rgb(255, 153, 0);
}

.v3 {
    border: 3px solid rgb(0, 247, 255);
    background-color: rgba(0, 238, 255, 0.315);
}
.v3.heading {
    background-color: rgb(0, 247, 255);;
}`, "",{"version":3,"sources":["webpack://./src/general_assets/containers.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;AAC9B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,yCAAyC;IACzC,0BAA0B;AAC9B;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;AACA;IACI,kCAAkC;AACtC","sourcesContent":[".box {\r\n    flex-grow: 1;\r\n    border-radius: 5px;\r\n    margin: 10px;\r\n}\r\n\r\n.heading {\r\n    margin: -3px -3px 0 auto;\r\n    font-size: 0.8rem;\r\n    color: black;\r\n    width: fit-content;\r\n    padding: 2px 15px 2px 15px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.box_internal {\r\n    height: calc(100% - 0.8rem - 12px);\r\n    width: 100%;\r\n    overflow: scroll;\r\n}\r\n\r\n.v1 {\r\n    border: 3px solid white;\r\n    background-color: rgba(255, 255, 255, 0.075);\r\n    backdrop-filter: blur(3px);\r\n}\r\n.v1.heading {\r\n    background-color: white;\r\n}\r\n\r\n.v2 {\r\n    border: 3px solid rgb(255, 145, 0);\r\n    background-color: rgb(255, 145, 0, 0.075);\r\n    backdrop-filter: blur(2px);\r\n}\r\n.v2.heading {\r\n    background-color: rgb(255, 153, 0);\r\n}\r\n\r\n.v3 {\r\n    border: 3px solid rgb(0, 247, 255);\r\n    background-color: rgba(0, 238, 255, 0.315);\r\n}\r\n.v3.heading {\r\n    background-color: rgb(0, 247, 255);;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
